import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  ADDIN_CORE_CONFIG,
  AddInCoreConfig,
  authTokenInterceptor,
  ConfigService,
  tenantBaseUrlInterceptor
} from '@cmi/addin-core';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tenantBaseUrlInterceptor, authTokenInterceptor])),
    provideAppInitializer(() => inject(ConfigService).load()),
    {
      provide: ADDIN_CORE_CONFIG,
      useValue: { homeRoute: '/', settingsEntries: [] } satisfies AddInCoreConfig
    },
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ]
};
